import FormContainer from "./tables/gold/FormContainer";

export default function TableGold() {
    return (
      <div className="p-3">
        <FormContainer/>
      </div>
    );
  }